import { useState } from "react";

import { passwordStrength } from "check-password-strength";

export const useCheckPasswordStrength = () => {
  const [currentPasswordStrength, setCurrentPasswordStrength] = useState({
    length: 0,
    strength: 0,
    uppercase: false,
    lowercase: false,
    number: false,
    symbol: false,
    password: "",
    checkPassword: "",
  });

  const setPasswordStrength = (e) => {
    e.persist();
    if (e.target.value !== "") {
      const strength = passwordStrength(e.target.value);
      setCurrentPasswordStrength({
        ...currentPasswordStrength,
        length: strength.length,
        strength: strength.id,
        uppercase: strength.contains.some((v) => v === "uppercase"),
        lowercase: strength.contains.some((v) => v === "lowercase"),
        number: strength.contains.some((v) => v === "number"),
        symbol: strength.contains.some((v) => v === "symbol"),
        password: e.target.value,
      });
    } else {
      setCurrentPasswordStrength({
        ...currentPasswordStrength,
        length: 0,
        strength: 0,
        uppercase: false,
        lowercase: false,
        number: false,
        symbol: false,
        password: "",
      });
    }
  };

  const setPasswordMatch = (e) => {
    e.persist();
    setCurrentPasswordStrength({
      ...currentPasswordStrength,
      checkPassword: e.target.value,
    });
  };

  return {
    currentPasswordStrength,
    setPasswordStrength,
    setPasswordMatch,
  };
};
